import styled from 'styled-components';
import { useStore } from '../hooks/useStore';

const Loader = styled.div`
  width: ${props => props.inline ? 'auto' : '100%'};
  height: 100%;
  min-height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const Text = styled.div`
  font-family: var(--main-font);
  font-size: 15px;
`;

function LoadingAnim(props) {
  const [state, dispatch] = useStore();
  const { appData } = state;
  return (
    <Loader id="snitch" inline={props.inline}>
      {appData && <img src={appData.loading_animation} />}
      {props.text && <Text>{props.text}</Text>}
    </Loader>
  );
}
export default LoadingAnim;
